import { render } from "./Add.vue?vue&type=template&id=271d1b34&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=271d1b34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-271d1b34"

export default script